import React from "react";
import { connect } from "react-redux";
import { getFormValues } from "redux-form";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import { ICustomer } from "models/.";
import { getFormatted } from "helpers/formatting";
import BackgroundBlock from "../../partials/BackgroundBlock";
import ButtonsRow from "../../partials/ButtonsRow";
import MyDeliveryActions from "../../actions";

import "./style.scss";

interface IProps {
  currentCustomer: ICustomer;
  formValues: any;
  goBack: () => void;
  createDeliveryNotes: (data: any, showCertificates: boolean) => void;
}

class StepSix extends React.Component<IProps> {
  private save = () => {
    const { formValues, createDeliveryNotes, currentCustomer } = this.props;

    createDeliveryNotes(formValues, currentCustomer?.ShowCertificates);
  };

  public render() {
    const { formValues, currentCustomer, goBack } = this.props;

    const fustLines = _.filter(formValues.fustLines, (line) => {
      const buyContainer = _.get(line, "buyContainer.value", {});

      return buyContainer && buyContainer !== "NVT";
    });

    return (
      <div id="step-six">
        <div>
          <div className="step-six-header">
            <FormattedMessage id="DELIVERIES_ADDRESS_HEADER" />
          </div>
          <BackgroundBlock className="first-block">
            <div className="first-block-column">
              <div className="title">
                <FormattedMessage id="DATE" tagName="p" />
                <FormattedMessage id="DELIVERIED_BY" tagName="p" />
                <FormattedMessage id="DELIVERIED_TO" tagName="p" />
                <FormattedMessage id="DELIVERIES_POSTAGE" tagName="p" />
                <FormattedMessage id="TRANSPORT" tagName="p" />
              </div>
              <div>
                <p>{getFormatted(formValues.date, "date")}</p>
                <p>{currentCustomer.Name}</p>
                <p>{formValues.buyer.Name}</p>
                <p>{_.get(formValues, "transport.freightCosts.label", "-")}</p>
                <p>{_.get(formValues, "transport.transporter", "-")}</p>
              </div>
            </div>
            <div className="first-block-column">
              <div className="title">
                <FormattedMessage id="DELIVERIES_CITY" tagName="p" />
                <p>{formValues.deleveryTypeId}</p>
              </div>
              <div>
                <p>{_.get(formValues, "transport.cityShipment", "-")}</p>
                <p>{_.get(formValues, "address.Address1", "-")}</p>
                {_.get(formValues, "address.Address1") && (
                  <p>
                    {`${_.get(formValues, "address.ZipCode", "-")}
                      ${_.get(formValues, "address.City", "-")},
                      ${_.get(formValues, "address.Country.ISOCode", "-")}`}
                  </p>
                )}
              </div>
            </div>
          </BackgroundBlock>
        </div>
        {!_.isEmpty(formValues.orderLines) && (
          <div>
            <div className="step-six-header">
              <FormattedMessage id="DELIVERY" />
            </div>
            {formValues.orderLines.map((item, index) => (
              <BackgroundBlock key={index}>
                <div className="second-block-row-wrapper">
                  <div className="second-block-row first-row">
                    <div>
                      <p className="title">
                        <FormattedMessage id="DELIVERIES_FUST" />
                      </p>
                      <p>{_.get(item, "fust", "-")}</p>
                    </div>
                    <div>
                      <p className="title">
                        <FormattedMessage id="DELIVERIES_PER_FUST" />
                      </p>
                      <p>{getFormatted(item.perFust, "number")}</p>
                    </div>
                    <div>
                      <p className="title">
                        <FormattedMessage id="DELIVERIES_REST_FUST" />
                      </p>
                      <p>{getFormatted(item.restFust, "number")}</p>
                    </div>
                    <div>
                      <p className="title">
                        <FormattedMessage id="DELIVERIES_TOTAL" />
                      </p>
                      <p>{getFormatted(item.total, "number")}</p>
                    </div>
                    <div>
                      <p className="title">
                        <FormattedMessage id="DELIVERIES_GENUS" />
                      </p>
                      <p>{_.get(item, "code", "-")}</p>
                    </div>
                    <div>
                      <p className="title">
                        <FormattedMessage id="DELIVERIES_CULTIVAR" />
                      </p>
                      <p>{_.get(item, "cultivar", "-")}</p>
                    </div>
                    <div>
                      <p className="title">
                        <FormattedMessage id="SIZE" />
                      </p>
                      <p>{_.get(item, "maat", "-")}</p>
                    </div>
                  </div>
                  <div className="second-block-row first-row">
                    <div>
                      <p className="title">
                        <FormattedMessage id="DELIVERIES_CLASS" />
                      </p>
                      <p>{_.get(item, "class.label", "-")}</p>
                    </div>
                    <div>
                      <p className="title">
                        <FormattedMessage id="DELIVERIES_AM_TYPE" />
                      </p>
                      <p>{_.get(item, "status.label", "-")}</p>
                    </div>
                    <div>
                      <p className="title">
                        <FormattedMessage id="DELIVERIES_BKD" />
                      </p>
                      <p>{_.get(item, "certificate", "-")}</p>
                    </div>
                    <div>
                      <p className="title">
                        <FormattedMessage id="DELIVERIES_BATCH" />
                      </p>
                      <p>{_.get(item, "party.label", "-")}</p>
                    </div>
                    <div>
                      <p className="title">
                        <FormattedMessage id="BIO" />
                      </p>
                      <p>{getFormatted(item.bio, "boolean")}</p>
                    </div>
                  </div>
                </div>
                <div>
                  <p className="title">
                    <FormattedMessage id="COMMENT" />
                  </p>
                  <p className="notes">{_.get(item, "comment", "-")}</p>
                </div>
              </BackgroundBlock>
            ))}
          </div>
        )}
        {!_.isEmpty(fustLines) && (
          <div>
            <div className="step-six-header">
              <FormattedMessage id="DELIVERIES_FUST_HEADER" />
            </div>
            {fustLines.map((item, index) => (
              <BackgroundBlock key={index}>
                <div className="second-block-row">
                  <div>
                    <p className="title">
                      <FormattedMessage id="DELIVERIES_FUST" />
                    </p>
                    <p>{_.get(item, "fust", "-")}</p>
                  </div>
                  <div>
                    <p className="title">
                      <FormattedMessage id="TYPE" />
                    </p>
                    <p>{_.get(item, "type.label", "-")}</p>
                  </div>
                  <div>
                    <p className="title">
                      <FormattedMessage id="KIND" />
                    </p>
                    <p>{_.get(item, "kind.label", "-")}</p>
                  </div>
                  <div>
                    <p className="title">
                      <FormattedMessage id="DELIVERIES_TRANSFER" />
                    </p>
                    <p>{_.get(item, "buyContainer.label", "-")}</p>
                  </div>
                  <div>
                    <p className="title">
                      <FormattedMessage id="DELIVERIES_PRICE_ONE" />
                    </p>
                    <p>{getFormatted(item.price, "number")}</p>
                  </div>
                  <div>
                    <p className="title">
                      <FormattedMessage id="TOTAL" />
                    </p>
                    <p>{getFormatted(item.total, "number")}</p>
                  </div>
                  <div>
                    <p className="title">
                      <FormattedMessage id="DELIVERIES_FOR" />
                    </p>
                    <p>{_.get(item, "costTo.label", "-")}</p>
                  </div>
                </div>
                <div>
                  <p className="title">
                    <FormattedMessage id="COMMENT" />
                  </p>
                  <p className="notes">{_.get(item, "comment", "-")}</p>
                </div>
              </BackgroundBlock>
            ))}
          </div>
        )}
        {!_.isEmpty(formValues.extraCostLines) && (
          <div>
            <div className="step-six-header">
              <FormattedMessage id="COST" />
            </div>
            {formValues.extraCostLines.map((item, index) => (
              <BackgroundBlock key={index}>
                <div className="fourth-block-row">
                  <div>
                    <p className="title">
                      <FormattedMessage id="ARTICLE" />
                    </p>
                    <p>{_.get(item, "article.label", "-")}</p>
                  </div>
                  <div>
                    <p className="title">
                      <FormattedMessage id="DESCRIPTION" />
                    </p>
                    <p>{_.get(item, "description", "-")}</p>
                  </div>
                  <div>
                    <p className="title">
                      <FormattedMessage id="AMOUNT" />
                    </p>
                    <p>{getFormatted(_.get(item, "amount", ""), "number")}</p>
                  </div>
                  <div>
                    <p className="title">
                      <FormattedMessage id="DELIVERIES_FOR" />
                    </p>
                    <p>{_.get(item, "costTo.label", "-")}</p>
                  </div>
                </div>
                <div>
                  <p className="title">
                    <FormattedMessage id="COMMENT" />
                  </p>
                  <p className="notes">{_.get(item, "comment", "-")}</p>
                </div>
              </BackgroundBlock>
            ))}
          </div>
        )}
        <div>
          <div className="step-six-header">
            <FormattedMessage id="DELIVERIES_COMMENT_SUPPLIER" />
          </div>
          <BackgroundBlock>
            <p className="notes">{_.get(formValues, "comment", "-")}</p>
          </BackgroundBlock>
        </div>
        <div>
          <div className="step-six-header">
            <FormattedMessage id="DELIVERIES_COMMENT_TRANSPORT" />
          </div>
          <BackgroundBlock>
            <p className="notes">
              {_.get(formValues, "transport.comment", "-")}
            </p>
          </BackgroundBlock>
        </div>
        <ButtonsRow goNext={this.save} goBack={goBack} showBackBtn lastStep />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    currentCustomer: state.app.currentCustomer,
    formValues: getFormValues("delivery")(state),
  }),
  {
    createDeliveryNotes: MyDeliveryActions.createDeliveryNotes,
  }
)(StepSix);
